/**
 * Bootstrap para Live Shopping Channelize (SFCC).
 * Lê a configuração dos data-attributes do container, define initChannelizeLiveBroadcastPlaylistOptions
 * e carrega o script da playlist para garantir ordem de execução correta.
 */
(function () {
    "use strict";

    var CHANNELIZE_SCRIPT_ID = "channelize-live-shows-playlist";
    var CHANNELIZE_SCRIPT_URL = "https://cdn.channelize.io/live-broadcast/embed/prod/playlist-embed.js";

    function getCsrfFromPage() {
        var el = document.querySelector(".tracking-consent[data-tokenName][data-token]");
        if (el && el.getAttribute("data-token")) {
            return { name: el.getAttribute("data-tokenName"), value: el.getAttribute("data-token") };
        }
        var input = document.querySelector("input[name*=\"csrf_token\"], input[name*=\"csrf\"]");
        if (input && input.name && input.value) {
            return { name: input.name, value: input.value };
        }
        return null;
    }

    function initChannelize() {
        var container = document.querySelector(".channelize-live-shopping-container");
        if (!container) return;

        var publicKey = container.getAttribute("data-channelize-public-key") || "s6H9AyeLISgrM2dX";
        var cartPageUrl = container.getAttribute("data-cart-page-url") || (window.location.origin + "/cart");
        var addToCartUrl = container.getAttribute("data-add-to-cart-url") || "";
        var cartGetUrl = container.getAttribute("data-cart-get-url") || "";
        var productsDetailsUrl = container.getAttribute("data-products-details-url") || "";

        // Log para confirmar no console qual rota está sendo usada no add-to-cart
        if (typeof console !== "undefined" && console.log) {
            console.log("[Channelize Live Shopping] Add to cart URL (rota):", addToCartUrl || "(vazio - verificar data-add-to-cart-url no container)");
        }

        window.initChannelizeLiveBroadcastPlaylistOptions = {
            publicKey: publicKey,
            settings: {
                locale: "es",
                cartUrl: cartPageUrl
            },
            doFetchProductsRequest: function (event, productUpdateCb) {
                var productIds = (event && event.products) ? event.products.map(function (p) { return p.id || p; }) : [];
                if (!productIds.length) {
                    if (productUpdateCb) productUpdateCb([]);
                    return;
                }
                var url = productsDetailsUrl + (productsDetailsUrl.indexOf("?") >= 0 ? "&" : "?") + "pids=" + productIds.join(",");
                fetch(url, { method: "GET", credentials: "same-origin" })
                    .then(function (r) { return r.json(); })
                    .then(function (products) {
                        if (productUpdateCb) productUpdateCb(products || []);
                    })
                    .catch(function () { if (productUpdateCb) productUpdateCb([]); });
            },
            doFetchCartRequest: function (event, callback) {
                fetch(cartGetUrl, { method: "GET", credentials: "same-origin" })
                    .then(function (r) { return r.json(); })
                    .then(function (cartData) {
                        if (callback) callback(cartData || {});
                    })
                    .catch(function () { if (callback) callback({}); });
            },
            addToCartRequest: function (event, callback) {
                var sku = (event && event.product) ? (event.product.id || event.product) : "";
                var quantity = (event && event.quantity) ? event.quantity : 1;
                if (!sku) {
                    if (callback) callback({ error: true, message: "SKU no válido" });
                    return;
                }
                var body = "pid=" + encodeURIComponent(sku) + "&quantity=" + quantity;
                var csrf = getCsrfFromPage();
                if (csrf) body += "&" + encodeURIComponent(csrf.name) + "=" + encodeURIComponent(csrf.value);

                if (typeof console !== "undefined" && console.log) {
                    console.log("[Channelize Live Shopping] addToCartRequest → POST:", addToCartUrl, "body:", body);
                }
                fetch(addToCartUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    credentials: "same-origin",
                    body: body
                })
                    .then(function (r) { return r.json(); })
                    .then(function (data) {
                        var errMsg = (data && data.errorMessage) || (data && data.message) || (data && data.error);
                        if (callback) callback(data && data.error ? { error: true, message: errMsg } : { error: false });
                    })
                    .catch(function (err) {
                        if (callback) callback({ error: true, message: err && err.message ? err.message : "Error de red" });
                    });
            },
            onCartUpdated: function () {
                if (typeof $ !== "undefined" && $.fn && $("body").trigger) {
                    $("body").trigger("cart:update");
                }
            }
        };

        /**
         * Intercepta cliques em links de "añadir a la cesta" / produto dentro do widget Channelize.
         * Se o Channelize usar link para a PDP, evitamos a navegação e fazemos add-to-cart via AJAX.
         */
        function extractPidFromElement(el) {
            if (!el) return null;
            var node = el;
            for (var i = 0; i < 10 && node; i++) {
                var pid = node.getAttribute && (node.getAttribute("data-product-id") || node.getAttribute("data-pid") || node.getAttribute("data-productid"));
                if (pid) return pid;
                node = node.parentElement;
            }
            return null;
        }
        function extractPidFromUrl(href) {
            if (!href) return null;
            try {
                var url = new URL(href, window.location.origin);
                var pid = url.searchParams.get("pid");
                if (pid) return pid;
                var path = url.pathname || "";
                var match = path.match(/-(\d+)\.html$/);
                if (match) return match[1];
            } catch (e) { /* ignore */ }
            return null;
        }
        function doAddToCart(pid, quantity, cb) {
            quantity = quantity || 1;
            var body = "pid=" + encodeURIComponent(pid) + "&quantity=" + quantity;
            var csrf = getCsrfFromPage();
            if (csrf) body += "&" + encodeURIComponent(csrf.name) + "=" + encodeURIComponent(csrf.value);
            if (typeof console !== "undefined" && console.log) {
                console.log("[Channelize Live Shopping] Interceptor add-to-cart → POST:", addToCartUrl, "body:", body);
            }
            fetch(addToCartUrl, {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                credentials: "same-origin",
                body: body
            })
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (typeof $ !== "undefined" && $.fn && $("body").trigger) {
                        $("body").trigger("cart:update");
                        if (data && !data.error && data.quantityTotal != null) {
                            $(".minicart").trigger("count:update", data);
                        }
                    }
                    if (cb) cb(data && data.error ? { error: true, message: data.errorMessage || data.message } : { error: false });
                })
                .catch(function (err) {
                    if (cb) cb({ error: true, message: err && err.message ? err.message : "Error de red" });
                });
        }
        container.addEventListener("click", function (e) {
            var target = e.target;
            var link = target && target.closest ? target.closest("a[href]") : null;
            if (!link || !link.href) return;
            var href = link.getAttribute("href") || link.href;
            var isProductOrCartLink = href.indexOf("Product-Show") !== -1
                || href.indexOf("/p/") !== -1
                || /-\d+\.html$/.test(href)
                || /\.html(\?|$)/.test(href);
            var isAddToCart = (target.textContent || "").toLowerCase().indexOf("añadir") !== -1
                || (target.textContent || "").toLowerCase().indexOf("agregar") !== -1
                || (target.textContent || "").toLowerCase().indexOf("cesta") !== -1
                || (target.textContent || "").toLowerCase().indexOf("carrito") !== -1
                || (link.textContent || "").toLowerCase().indexOf("añadir") !== -1
                || (link.textContent || "").toLowerCase().indexOf("cesta") !== -1;
            if (!isProductOrCartLink && !isAddToCart) return;
            var pid = extractPidFromElement(target) || extractPidFromElement(link) || extractPidFromUrl(href);
            if (!pid) return;
            e.preventDefault();
            e.stopPropagation();
            doAddToCart(pid, 1);
        }, true);

        if (!document.getElementById(CHANNELIZE_SCRIPT_ID)) {
            var script = document.createElement("script");
            script.id = CHANNELIZE_SCRIPT_ID;
            script.src = CHANNELIZE_SCRIPT_URL;
            script.async = false;
            (document.head || document.documentElement).appendChild(script);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initChannelize);
    } else {
        initChannelize();
    }
})();
